module.exports = __webpack_public_path__ + "img/interface.6ee7d065.svg";